export const organizationRequest = [{
  id: true,
  version: true,
  identifier: true,
  archivedAt: true,
  prunePeriod: true
}];
